
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import QualityPendingList from '@/components/quality/QualityPendingList';
import QualityPendingFinalList from '@/components/quality/QualityPendingFinalList';
import QualityApprovedList from '@/components/quality/QualityApprovedList';
import QualityRejectedList from '@/components/quality/QualityRejectedList';

const Quality = () => {
  return (
    <Layout fullWidth>
      <div className="p-6 space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Quality Inspection</h1>
          <p className="text-muted-foreground mt-1">
            Inspect sample size and damage percentage before warehouse confirmation
          </p>
        </div>

        <Tabs defaultValue="pending" className="w-full">
          <TabsList>
            <TabsTrigger value="pending">Pending Inspection</TabsTrigger>
            <TabsTrigger value="pending-final">Pending Final Grading</TabsTrigger>
            <TabsTrigger value="approved">Approved</TabsTrigger>
            <TabsTrigger value="rejected">Rejected</TabsTrigger>
          </TabsList>

          <TabsContent value="pending">
            <QualityPendingList />
          </TabsContent>

          <TabsContent value="pending-final">
            <QualityPendingFinalList />
          </TabsContent>

          <TabsContent value="approved">
            <QualityApprovedList />
          </TabsContent>

          <TabsContent value="rejected">
            <QualityRejectedList />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
};

export default Quality;
